import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ProjectPermissions } from '../types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (): Promise<ProjectPermissions | null> =>
	fetchJson('/rest/internal/2/projectpermissions');
